import { GuestHotelScheduleLiteModel } from 'api-hooks/cro/model';
import * as Yup from 'yup';

const HotelScheduleDetailFormSchema = () =>
  Yup.object({
    id: Yup.string().default(''),
    checkInStatus: Yup.string().nullable().default(null),
    hotelConfirmationCode: Yup.string().default(''),
    //additional information
    isCheck: Yup.boolean().default(false),
  });

export const HotelScheduleFormSchema = () =>
  Yup.object({
    hotelSchedules: Yup.array(HotelScheduleDetailFormSchema()).default([]),
  });

export type HotelScheduleFormType = {
  hotelSchedules: HotelScheduleDetailFormType[];
  data: GuestHotelScheduleLiteModel[];
};

export type HotelScheduleDetailFormType = GuestHotelScheduleLiteModel &
  Yup.InferType<ReturnType<typeof HotelScheduleDetailFormSchema>>;
